var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"widget"})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@14.2.4_babel-core@6.26.3_supports-color@5.5.0__css-loader@0.28.11_handlebars_113b7769537605c3d521a8736433f671/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683a6324","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@14.2.4_babel-core@6.26.3_supports-color@5.5.0__css-loader@0.28.11_handlebars_113b7769537605c3d521a8736433f671/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/shared/components/kendo-grid/kendo-grid.component.vue
// module id = null
// module chunks = 